import { Component } from '@angular/core';

import { version } from '../../../../package.json';
import { environment } from '../environments/environment';

const logStyles = 'font-weight: bold; font-size: 14px';
const versionText = `Version: ${version}`;
const changelogLink = environment.production
  ? ''
  : `(https://sites.google.com/view/tripointe-wiki/changelog)`;

@Component({
  selector: 'tp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'tripointe-cms';

  constructor() {
    console.log(`%c${versionText}${changelogLink}`, logStyles);
  }
}
